module.exports = __webpack_public_path__ + "static/img/14000044.25e4abe4.png";